import { find, findAll, register } from '../../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const mobileMenu = document.getElementById('mobileMenu')
  const menuLinks = findAll('.medacOrganismHeaderMobilenav-navigationLink ')
  const mobileMenuBtn = document.getElementById('mobileMenuBtn')
  const subMenuFirstLevel = findAll(`.${componentPrefix}hasSubmenu`, el)
  const closeNav = find(`.${componentPrefix}closeNav`, el)
  const languageMenu = find(`.${componentPrefix}languageNavigation`, el)

  menuLinks.forEach(element => {
    element.addEventListener('click', function (e) {
      mobileMenu.classList.toggle(`${componentPrefix}-active`)
      document.firstElementChild.classList.remove('nav-open')
    })
  })

  subMenuFirstLevel.forEach(element => {
    element.addEventListener('click', function (e) {
      e.currentTarget.classList.toggle(`${componentPrefix}open`)
      e.currentTarget.children[1].classList.toggle(`${componentPrefix}submenu-active`)
    })
  })

  if (typeof (languageMenu) !== 'undefined' && languageMenu != null) {
    languageMenu.addEventListener('click', function () {
      languageMenu.classList.toggle(`${componentPrefix}-active`)
    })
  }

  mobileMenuBtn.addEventListener('click', function () {
    mobileMenu.classList.toggle(`${componentPrefix}-active`)
    document.firstElementChild.classList.toggle('nav-open')
  })

  closeNav.addEventListener('click', function () {
    mobileMenu.classList.remove(`${componentPrefix}-active`)
    document.firstElementChild.classList.remove('nav-open')
  })
}

register('mobileNav', component)
